// wraps window function (initialised in plain JS on the index.html) and brings the values into TS land so we don't have
// to use ts-ignore or ts-expect-error everywhere
const origin = () => {
    // @ts-expect-error
    return window.apiOrigin();
};
const API_ORIGIN = origin();
export default {
    origin,
    ORIGIN: API_ORIGIN,
    API_ORIGIN
};
